import Button, { ButtonProps } from '../button/Button';
import { useWaFilterStore } from 'src/api/wa/store/WaFilterStore';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

type PropertiesHeaderProps = {
  title: string;
  buttons: ButtonProps[];
};

function PropertiesHeader({ title, buttons }: PropertiesHeaderProps) {
  const { setFilterChanged } = useWaFilterStore();
  const filterChanged = useWaFilterStore((s) => s.filterChanged);
  const { t } = useTranslation();

  useEffect(() => {
    if (filterChanged) {
      const timerId = setTimeout(() => {
        setFilterChanged(false);
      }, 3000);
      return () => {
        clearTimeout(timerId);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterChanged]);

  return (
    <div className="flex flex-col items-center bg-gray-100 px-4 py-8">
      <h2 className="mb-6 text-center text-2xl font-bold">{title}</h2>
      {filterChanged && (
        <p className="mb-4 text-sm text-red-600">{t('wards.header.changeMessage')}</p>
      )}
      <div className="grid w-full grid-cols-2 gap-4">
        {buttons.map((item) => (
          <div key={item.key} className="size-full">
            <Button
              {...(item.onClick && { onClick: item.onClick })}
              {...(item.title !== undefined && { title: item.title })}
              className="size-full"
              {...(item.disabled !== undefined && { disabled: item.disabled })}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default PropertiesHeader;
